import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { Modal, ModalContent, Button as ButtonV2, ButtonProps } from '@restworld/ui-ds-base';

import { cn } from '@restworld/utils-common';
export interface IFormModalWrapper {
  loading?: boolean;
  onSubmitHandler?: () => void;
  onCancelHandler?: () => void;
  modalVisible?: boolean;
  onModalClose?: () => void;
  title?: string;
  subTitle?: string;
  submitHandlerProps?: Omit<ButtonProps, 'variant'>;
  headerIcon?: React.ReactNode;
  onCancelHandlerProps?: Omit<ButtonProps, 'variant'>;
}

export const ModalToggleWrapper = ({
  children,
  loading,
  onSubmitHandler,
  onCancelHandler,
  modalVisible,
  onModalClose,
  title,
  subTitle,
  submitHandlerProps,
  headerIcon,
  onCancelHandlerProps,
}: React.PropsWithChildren<IFormModalWrapper>) => {
  const { t } = useTranslation('user-settings');

  const footer = React.useMemo(
    () => (
      <div className="flex flex-row gap-5 w-full">
        {(onCancelHandler || onCancelHandlerProps?.onClick) && (
          <ButtonV2 fullwidth variant="tertiary" onClick={onCancelHandler} {...onCancelHandlerProps}>
            {t('cancel')}
          </ButtonV2>
        )}
        <ButtonV2 loading={loading} fullwidth onClick={onSubmitHandler} {...submitHandlerProps}>
          {t('confirm')}
        </ButtonV2>
      </div>
    ),
    [loading, onCancelHandler, onCancelHandlerProps, onSubmitHandler, submitHandlerProps, t]
  );
  return (
    <Modal open={modalVisible} onOpenChange={(v) => !v && onModalClose()}>
      <ModalContent className="md:max-w-md" footer={footer} title={title}>
        <Form action="#!" method="post" onSubmit={(e) => e.preventDefault()}>
          {(headerIcon || subTitle) && (
            <div className="flex flex-col gap-2 items-center">
              {headerIcon}
              {subTitle && <p className="text-base font-medium text-neutral-200 text-center">{subTitle}</p>}
            </div>
          )}
          {children}
        </Form>
      </ModalContent>
    </Modal>
  );
};

const Form = ({ className, ...props }: React.FormHTMLAttributes<HTMLFormElement>) => (
  <form className={cn('flex flex-col gap-8 pb-12 pt-4 w-full', className)} {...props} />
);
